import {ChangeDetectionStrategy, Component, OnDestroy} from '@angular/core';
import {AgRendererComponent} from 'ag-grid-angular';
import {IrbModelsEvents} from '@irb/irb-models/irb-models.events';
import {AppService} from '@irb/app.service';

@Component({ standalone: false,
  selector: 'irb-model-read-cell',
  template: `
    @if (isMMCModel) {
      <div [ngClass]="modelChangeReadIcon" style="width: 100%; background-position: center;"
      (click)="onClick()"></div>
    }`,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ModelReadCellComponent implements AgRendererComponent, OnDestroy {

  params: any;
  modelChangeReadIcon: string;
  isMMCModel = false;

  constructor(private as: AppService) {}

  refresh(): boolean {
    return false;
  }

  agInit(params: any) {
    this.params = params;   
    if (this.params) {
      if (this.params.data.modelMarketId) {
        this.isMMCModel = true;
        if (this.params.data.isRead && this.params.data.isRead == true) {
          this.modelChangeReadIcon = 'envelope_read';
        } else if (this.params.data.isRead == false) {
          this.modelChangeReadIcon = 'envelope_unread';
        }
      }
    }
  }

  onClick() {
    if (this.modelChangeReadIcon === 'envelope_unread') {
      let eventData: any = this.params.data;
      eventData.fullscreen = true;
      eventData.openHistory = true;
      this.as.fireEvent(IrbModelsEvents.SHOW_EDIT_MODEL, eventData);
    }
  }

  ngOnDestroy(): void {

  }
}
